import AmenitiesColumn from './AmenitiesColumn';
import SeePricingButton from './SeePricingButton';
import moment from 'moment';

// Headers for the PnA unit table. Built as a factory so the "See pricing" action
// column can capture the `onSeePricing` callback (table render fns only receive
// rowData). Reads the new unit-index shape directly (no adapter).
export const buildPnaTableConfig = ({ onSeePricing }) => ({
  headers: [
    {
      displayName: 'Unit',
      // API always resolves displayUnitName (building-qualified for Entrata,
      // e.g. 10-103; falls back to unitName otherwise), so display/sort read it
      // directly — no UI-side fallback. (ZUM-3352)
      key: 'displayUnitName',
      tooltip: false
    },
    {
      displayName: 'Bed',
      key: 'bedRooms',
      tooltip: false
    },
    {
      displayName: 'Bath',
      key: 'bathRooms',
      tooltip: false
    },
    {
      displayName: 'Price',
      key: 'rent.min',
      tooltip: false,
      render: rowData => (
        <>{rowData?.rent?.min ? `$${rowData?.rent?.min}` : 'N/A'}</>
      )
    },
    {
      displayName: 'Availability',
      key: 'availableFrom',
      sortValue: rowData =>
        rowData?.availableFrom ? moment(rowData.availableFrom).valueOf() : 0,
      render: rowData => (
        <>
          {rowData?.availableFrom &&
            moment(rowData?.availableFrom).format("DD' MMM YY")}
        </>
      )
    },
    {
      displayName: 'Floor',
      key: 'floorNumber',
      tooltip: false,
      render: rowData => <>{rowData?.floorNumber ?? 'N/A'}</>
    },
    {
      displayName: 'Floor Plan',
      key: 'floorPlan',
      tooltip: false,
      render: rowData => <>{rowData?.floorPlan || 'N/A'}</>
    },
    {
      displayName: 'Area',
      key: 'sqft',
      tooltip: false,
      render: rowData => <>{rowData.sqft ? rowData.sqft : '0'} sqft</>
    },
    {
      displayName: 'Lease Term',
      key: 'columnName6',
      tooltip: false,
      render: rowData => (
        <>
          {rowData?.leaseData?.leaseTerm ? rowData?.leaseData?.leaseTerm : 12}{' '}
          months
        </>
      )
    },
    {
      displayName: 'Amenities',
      key: 'amenities',
      tooltip: false,
      render: rowData => {
        return <AmenitiesColumn rowData={rowData} />;
      }
    },
    {
      displayName: '',
      key: 'rentMetrixAction',
      tooltip: false,
      render: rowData =>
        rowData?.rentMetrixAvailable ? (
          <SeePricingButton onClick={() => onSeePricing(rowData)} />
        ) : null
    }
  ]
});

export default buildPnaTableConfig;
